import { TreeApiState } from '/shared/NewTree/types';

export const virtualEntitiesActive = (treeNodes: TreeApiState['nodes']) => {
  const virtualEntities = [...treeNodes.values()].filter((node) => node.isVirtualEntity);
  return virtualEntities.some((item) => item.error !== undefined);
};
